import {PartnerBrandBankDataApiDto} from "../../api/model/rest";
import {none, option, Option} from "ts-option";

export default class PartnerBrandBankData {
	constructor(
		public readonly id: string,
		public readonly bankAccountNumber: string,
		public readonly bankSortCode: string,
		public readonly accountHolder: Option<string>
	) {}

	static fromJson(json: PartnerBrandBankDataApiDto): PartnerBrandBankData {
		return new PartnerBrandBankData(json.id, json.bankAccountNumber, json.bankSortCode, option(json.accountHolder));
	}

	static createEmpty() {
		return new PartnerBrandBankData("", "", "", none)
	}

	isProvided(): boolean {
		return !!this.bankAccountNumber.length && !!this.bankSortCode.length;
	}
}
